var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 17,
    viewBox: "0 0 66 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8864H1.3076L8.30096 2.55866L15.3175 16.8864H16.6251L8.30119 3.05176e-05L0 16.8864Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5103 16.8864H33.8179L40.8112 2.55866L47.8278 16.8864H49.1354L40.811 3.05176e-05L32.5103 16.8864Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4236 3.05176e-05H30.116L24.7327 7.18492L19.3585 3.05176e-05H18.0508L23.9702 8.11695L17.5962 16.8873H18.9038L24.7204 9.15053L30.5371 16.8873H31.8447L25.507 8.11695L31.4236 3.05176e-05Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7141 3.05206e-05C55.033 7.5459e-05 53.3897 0.498619 51.9919 1.43263C50.5941 2.36664 49.5047 3.69416 48.8613 5.24732C48.218 6.80048 48.0497 8.50954 48.3777 10.1584C48.7057 11.8072 49.5152 13.3217 50.704 14.5104C51.8927 15.6992 53.4072 16.5087 55.056 16.8367C56.7049 17.1647 58.4139 16.9964 59.9671 16.353C61.5202 15.7097 62.8478 14.6203 63.7818 13.2225C64.7158 11.8247 65.2143 10.1814 65.2144 8.50025C65.2144 7.38398 64.9946 6.27863 64.5674 5.24732C64.1402 4.21601 63.5141 3.27894 62.7248 2.48961C61.9355 1.70029 60.9984 1.07418 59.9671 0.647011C58.9358 0.219845 57.8304 6.81278e-07 56.7141 3.05206e-05V3.05206e-05ZM56.6985 15.8263C55.2464 15.8262 53.827 15.3956 52.6197 14.5889C51.4124 13.7821 50.4715 12.6355 49.9158 11.294C49.3602 9.95251 49.2148 8.47636 49.4981 7.05223C49.7814 5.62811 50.4806 4.31997 51.5073 3.29323C52.5341 2.26649 53.8422 1.56727 55.2663 1.28398C56.6905 1.00069 58.1666 1.14606 59.5081 1.70171C60.8496 2.25735 61.9962 3.19832 62.803 4.40562C63.6097 5.61292 64.0403 7.03233 64.0404 8.48436C64.0402 10.4314 63.2666 12.2986 61.8898 13.6753C60.513 15.0519 58.6457 15.8253 56.6987 15.8253L56.6985 15.8263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxaoIcon);
export default __webpack_public_path__ + "static/media/axaoIcon.708d0acda156af8e7aa6e6b948381c36.svg";
export { ForwardRef as ReactComponent };